// Needed global variable for tracking the which page the user is on
let pgCount = 0;
let sirensatFlag = false;

// Load the contents of the dom first before any functions are called affecting dom elements
// Adding event listeners to Email Me My Offer Button, See Results Button, and value increments for 
// reccomendations page for increases the product count. 
document.addEventListener("DOMContentLoaded", (event) => {
  let text_input = document.getElementById("byb-email-user-input");
  let ques10_input = document.getElementById("byb-ques10-pt2");

  // Add event listener here to reset text color for correct email entries 
  text_input.addEventListener("input", (e) => {
    text_input.style.color = "#555";
  })
  
  // Add event listener to Email Me My Offer Button
  // Prevent defualt event of form submission and when clicking the email me button, validate the email entry based
  // on valid email criteria. After process products and use Postmark to send to User's email. 
  let offer_btn = document.getElementById("send-offer-btn")
  offer_btn.addEventListener("click", (e) => {
    e.preventDefault();
    liveUpdateEmailInput(text_input);
    if(validateEmailByb(text_input.value)) {
      let userEmail = document.getElementById("byb-email-user-input").value;
      bybSendOffers(userEmail);
      successEmailDisplay();
    } 
    else {
      // place holder code || implement failure response
      console.log("Email is invalid please re-enter a correct email");
    }
  });

  // User submits email, verify email, and send offers
  // after question 10, the quiz display is set to none and reccomendatoins are shown
  let quest10_email = document.getElementById("see-results-btn")
  quest10_email.addEventListener("click", (e) => bybLoadFormContent(e)); 
    async function bybLoadFormContent(e) {
      e.preventDefault();
      await liveUpdateEmailInput(ques10_input);
      if(validateEmailByb(ques10_input.value)) {
        let userEmail = document.getElementById("byb-ques10-pt2").value;
        await bybProcessForm();
        await successEmailDisplay();
        await bybSendOffers(userEmail);
      } 
      else {
        // place holder code || implement failure response
        console.log("Email is invalid please re-enter a correct email");
      }
    } 
  
  // Add event listener on modal to return to recommendation page after sending email
  let returnBackBtn = document.getElementById("back-to-page-btn");
  returnBackBtn.addEventListener("click", (e) => {
    e.preventDefault();
  })

    // Add event listeners to numeric inputs to update values when user increments/decrements value
  let quantityInputs = document.querySelectorAll(`.byb-num-input`)
  quantityInputs.forEach(input => {
    input.addEventListener("input", (e) => {
      let currentVal = e.target.value;
    })
  })
})

function bybNextPage(input){
  if(input === -1){ //handle backarrow click, including steps w/ optional follow-up ques
    if(pgCount === 4){ //if "Boat theft" was unselected in ques 3, skip optional ques 3A
      if(sirensatFlag){
        input = -1;
      } else {
        input = -2;
      }
    }else if(pgCount === 7){ //if 0 entries were selected, skip canvas snap/audible alarm
      let entryQuant = document.getElementById("byb-ques-5").valueAsNumber;
      if(entryQuant === 0){
        input = -2;
      }
    }else if(pgCount === 11){ //if shore power was irrevant, skip shore power relay ques
      if(document.getElementById("byb-ques1-opt1").checked || document.getElementById("byb-ques8-opt3").checked || document.getElementById("byb-ques8-opt4").checked){
        input = -2;
      }
    }
  } else { //handle steps w/ custom logic
    if(input === 2){ //handle ques 2, a mandatory step
      let icons = {
        b1yes: 'https://cdn.shopify.com/s/files/1/1826/4365/files/Saltwater-Outline-Buttons.png?v=1772567495',
        b2yes: 'https://cdn.shopify.com/s/files/1/1826/4365/files/Fishing-Outline-Buttons.png?v=1772567496',
        b3yes: 'https://cdn.shopify.com/s/files/1/1826/4365/files/Pontoon-Outline-Buttons.png?v=1772567495',
        b4yes: 'https://cdn.shopify.com/s/files/1/1826/4365/files/Freshwater-Outline-Buttons.png?v=1772571206',
        b5yes: 'https://cdn.shopify.com/s/files/1/1826/4365/files/Center-Outline-Buttons.png?v=1772569450',
        b6yes: 'https://cdn.shopify.com/s/files/1/1826/4365/files/Sailboat-Outline-Buttons.png?v=1772567496',
        b7yes: 'https://cdn.shopify.com/s/files/1/1826/4365/files/Jetboat-Outline-Buttons_1.png?v=1772659189',
        b8yes: 'https://cdn.shopify.com/s/files/1/1826/4365/files/Inboard-Outline-Buttons.png?v=1772567496'
      } //
      let imgtags = {
        b1: document.getElementById('byb-ques2-opt1'),
        b2: document.getElementById('byb-ques2-opt2'),
        b3: document.getElementById('byb-ques2-opt3'),
        b4: document.getElementById('byb-ques2-opt4'),
        b5: document.getElementById('byb-ques2-opt5'),
        b6: document.getElementById('byb-ques2-opt6'),
        b7: document.getElementById('byb-ques2-opt7'),
        b8: document.getElementById('byb-ques2-opt8')
      }
      if(imgtags.b1.src == icons.b1yes ||
        imgtags.b2.src == icons.b2yes ||
        imgtags.b3.src == icons.b3yes ||
        imgtags.b4.src == icons.b4yes ||
        imgtags.b5.src == icons.b5yes ||
        imgtags.b6.src == icons.b6yes ||
        imgtags.b7.src == icons.b7yes ||
        imgtags.b8.src == icons.b8yes ){
        document.getElementById('byb-step2-prevent-next').style.display = 'none';
        input = 1;
      } else {
        document.getElementById('byb-step2-prevent-next').style.display = 'block';
        return;
      }
    } else if(input === 3){ //if boat theft selected, follow w ques 3a
      let boattheft = document.getElementById('byb-btn-ques3-4');
      if(boattheft.classList.contains('byb-btn-active')){
        let sailboatSelected = 'https://cdn.shopify.com/s/files/1/1826/4365/files/Sailboat-Outline-Buttons.png?v=1772567496';
        let offshoreSelected = 'https://cdn.shopify.com/s/files/1/1826/4365/files/Center-Outline-Buttons.png?v=1772569450';
        let sailboatChoice = document.getElementById('byb-ques2-opt6').src;
        let offshoreChoice = document.getElementById('byb-ques2-opt5').src;

        if(sailboatSelected === sailboatChoice || offshoreSelected === offshoreChoice){
          let s3owned = document.getElementById('byb-ques1-opt1').checked;
          if(!s3owned){
            input = 1;
            sirensatFlag = true;
          }
        }else{
          input = 2;
        }
      }else{
        input = 2;
      }
    }else if(input === 5){ //if >0 chosen, follow w ques 5a
      let ques5val = document.getElementById("byb-ques-5").valueAsNumber;
      if(ques5val > 0){
        input = 1;
      }else{
        input = 2;
      }
    }else if(input === 7){ //on ques 8, skip ques 9 if their storage method does not require shore power
      if(document.getElementById("byb-ques1-opt1").checked || document.getElementById("byb-ques8-opt3").checked || document.getElementById("byb-ques8-opt4").checked){
        input = 2;
      } else {
        input = 1;
      }
    }
  }

  //hide current tab
  let bybSteps = document.getElementsByClassName("byb-step");
  bybSteps[pgCount].style.display = "none";
  
  pgCount += input; //1 for next, -1 for prev
  
  ////After last ques, hide Quiz block & display Results block 
  // if(pgCount > 11){ 
  //   console.log('concluded')
  //   document.getElementById('byb-quiz-root').style.display = "none";
  //   document.getElementById('byb-result-root').style.display = "block";
  // } else {
    bybSteps[pgCount].style.display = "block";
    if(pgCount === 0){
      document.getElementById('byb-back-arrow').style.display = "none";
    } else {
      document.getElementById('byb-back-arrow').style.display = "block";
    }
  // }
  } 

  function bybToggleBtn(elem){
    //if elem is active, elem gets inactive
    let target = document.getElementById(elem);
    if(elem === 'byb-btn-ques3-4'){ //if "Boat Theft" clicked
      if(target.classList.contains('byb-btn-active')){ //if boat theft WAS selected, but becomes unselected, set SirenSat btn to inactive. And regular target behavior
        let satBtn = document.getElementById('byb-btn-ques3a-1');
        satBtn.classList.remove('byb-btn-active');
        satBtn.classList.add('byb-btn-inactive');
        sirensatFlag = false;
        target.classList.remove('byb-btn-active');
        target.classList.add('byb-btn-inactive');
      } else {
        target.classList.remove('byb-btn-inactive');
        target.classList.add('byb-btn-active');
      }
    }else if (elem === 'byb-btn-ques3a-1' || elem === 'byb-btn-ques3a-2'){ //toggle "Add A SirenSat" vs "Skip" so that only one is selected
      let satBtn = document.getElementById('byb-btn-ques3a-1');
      let satSkipBtn = document.getElementById('byb-btn-ques3a-2');
      if(satBtn.classList.contains('byb-btn-active')){
        satBtn.classList.remove('byb-btn-active');
        satBtn.classList.add('byb-btn-inactive');
        satSkipBtn.classList.add('byb-btn-active');
        satSkipBtn.classList.remove('byb-btn-inactive');
      }else{
        satBtn.classList.add('byb-btn-active');
        satBtn.classList.remove('byb-btn-inactive');
        satSkipBtn.classList.add('byb-btn-inactive');
        satSkipBtn.classList.remove('byb-btn-active');
      }
    }else{
      if(target.classList.contains('byb-btn-active')){
        target.classList.remove('byb-btn-active');
        target.classList.add('byb-btn-inactive');
      } else {
        target.classList.remove('byb-btn-inactive');
        target.classList.add('byb-btn-active');
      }
    }
  }

  function bybToggleImg(elem){
    let icons = {
      b1no: 'https://cdn.shopify.com/s/files/1/1826/4365/files/Saltwater-Grey-Outline-Buttons.png?v=1772567054',
      b1yes: 'https://cdn.shopify.com/s/files/1/1826/4365/files/Saltwater-Outline-Buttons.png?v=1772567495',
      b2no: 'https://cdn.shopify.com/s/files/1/1826/4365/files/Fishing-Grey-Outline-Buttons.png?v=1772567054',
      b2yes: 'https://cdn.shopify.com/s/files/1/1826/4365/files/Fishing-Outline-Buttons.png?v=1772567496',
      b3no: 'https://cdn.shopify.com/s/files/1/1826/4365/files/Pontoon-Grey-Outline-Buttons.png?v=1772567054',
      b3yes: 'https://cdn.shopify.com/s/files/1/1826/4365/files/Pontoon-Outline-Buttons.png?v=1772567495',
      b4no: 'https://cdn.shopify.com/s/files/1/1826/4365/files/Freshwater-Grey-Outline-Buttons.png?v=1772571207',
      b4yes: 'https://cdn.shopify.com/s/files/1/1826/4365/files/Freshwater-Outline-Buttons.png?v=1772571206',
      b5no: 'https://cdn.shopify.com/s/files/1/1826/4365/files/Center-Grey-Outline-Buttons.png?v=1772568610',
      b5yes: 'https://cdn.shopify.com/s/files/1/1826/4365/files/Center-Outline-Buttons.png?v=1772569450',
      b6no: 'https://cdn.shopify.com/s/files/1/1826/4365/files/Sailboat-Grey-Outline-Buttons.png?v=1772567054',
      b6yes: 'https://cdn.shopify.com/s/files/1/1826/4365/files/Sailboat-Outline-Buttons.png?v=1772567496',
      b7no: 'https://cdn.shopify.com/s/files/1/1826/4365/files/Jetboat-Grey-Outline-Buttons_1.png?v=1772659189',
      b7yes: 'https://cdn.shopify.com/s/files/1/1826/4365/files/Jetboat-Outline-Buttons_1.png?v=1772659189',
      b8no: 'https://cdn.shopify.com/s/files/1/1826/4365/files/Inboard-Grey-Outline-Buttons.png?v=1772567054',
      b8yes: 'https://cdn.shopify.com/s/files/1/1826/4365/files/Inboard-Outline-Buttons.png?v=1772567496'
    }
    let imgtags = {
      b1: document.getElementById('byb-ques2-opt1'),
      b2: document.getElementById('byb-ques2-opt2'),
      b3: document.getElementById('byb-ques2-opt3'),
      b4: document.getElementById('byb-ques2-opt4'),
      b5: document.getElementById('byb-ques2-opt5'),
      b6: document.getElementById('byb-ques2-opt6'),
      b7: document.getElementById('byb-ques2-opt7'),
      b8: document.getElementById('byb-ques2-opt8'),
    }
    let img = document.getElementById(elem);
    if(img.src == icons.b1no){
      img.src = icons.b1yes;
      imgtags.b2.src = icons.b2no;
      imgtags.b3.src = icons.b3no;
      imgtags.b4.src = icons.b4no;
      imgtags.b5.src = icons.b5no;
      imgtags.b6.src = icons.b6no;
      imgtags.b7.src = icons.b7no;
      imgtags.b8.src = icons.b8no;
    } else if(img.src == icons.b1yes){
      img.src = icons.b1no;
    }else if(img.src == icons.b2no){
      img.src = icons.b2yes;
      imgtags.b1.src = icons.b1no;
      imgtags.b3.src = icons.b3no;
      imgtags.b4.src = icons.b4no;
      imgtags.b5.src = icons.b5no;
      imgtags.b6.src = icons.b6no;
      imgtags.b7.src = icons.b7no;
      imgtags.b8.src = icons.b8no;
    }else if(img.src == icons.b2yes){
      img.src = icons.b2no;
    }else if(img.src == icons.b3no){
      img.src = icons.b3yes;
      imgtags.b1.src = icons.b1no;
      imgtags.b2.src = icons.b2no;
      imgtags.b4.src = icons.b4no;
      imgtags.b5.src = icons.b5no;
      imgtags.b6.src = icons.b6no;
      imgtags.b7.src = icons.b7no;
      imgtags.b8.src = icons.b8no;
    }else if(img.src == icons.b3yes){
      img.src = icons.b3no;
    }else if(img.src == icons.b4no){
      img.src = icons.b4yes;
      imgtags.b1.src = icons.b1no;
      imgtags.b2.src = icons.b2no;
      imgtags.b3.src = icons.b3no;
      imgtags.b5.src = icons.b5no;
      imgtags.b6.src = icons.b6no;
      imgtags.b7.src = icons.b7no;
      imgtags.b8.src = icons.b8no;
    }else if(img.src == icons.b4yes){
      img.src = icons.b4no;
    }else if(img.src == icons.b5no){
      img.src = icons.b5yes;
      imgtags.b1.src = icons.b1no;
      imgtags.b2.src = icons.b2no;
      imgtags.b3.src = icons.b3no;
      imgtags.b4.src = icons.b4no;
      imgtags.b6.src = icons.b6no;
      imgtags.b7.src = icons.b7no;
      imgtags.b8.src = icons.b8no;
    }else if(img.src == icons.b5yes){
      img.src = icons.b5no;
    }else if(img.src == icons.b6no){
      img.src = icons.b6yes;
      imgtags.b1.src = icons.b1no;
      imgtags.b2.src = icons.b2no;
      imgtags.b3.src = icons.b3no;
      imgtags.b4.src = icons.b4no;
      imgtags.b5.src = icons.b5no;
      imgtags.b7.src = icons.b7no;
      imgtags.b8.src = icons.b8no;
    }else if(img.src == icons.b6yes){
      img.src = icons.b6no;
    }else if(img.src == icons.b7no){
      img.src = icons.b7yes;
      imgtags.b1.src = icons.b1no;
      imgtags.b2.src = icons.b2no;
      imgtags.b3.src = icons.b3no;
      imgtags.b4.src = icons.b4no;
      imgtags.b5.src = icons.b5no;
      imgtags.b6.src = icons.b6no;
      imgtags.b8.src = icons.b8no;
    }else if(img.src == icons.b7yes){
      img.src = icons.b7no;
    }else if(img.src == icons.b8no){
      img.src = icons.b8yes;
      imgtags.b1.src = icons.b1no;
      imgtags.b2.src = icons.b2no;
      imgtags.b3.src = icons.b3no;
      imgtags.b4.src = icons.b4no;
      imgtags.b5.src = icons.b5no;
      imgtags.b6.src = icons.b6no;
      imgtags.b7.src = icons.b7no;
    }else if(img.src == icons.b8yes){
      img.src = icons.b8no;
    }
  }
  // From quiz questions, the form will process which products to select.
  // After product selection, the client will be shown the corresponding products and 
  // a Postmark email payload will be created and be sent to client including those same products.
  // Simultaneously, the quiz will determine which hubspot contact properties to update.
  // An axios call requests the backend server with productList object.  
  function bybProcessForm(){ //collect form results on submit
    let icons = {
      b1yes: 'https://cdn.shopify.com/s/files/1/1826/4365/files/Saltwater-Outline-Buttons.png?v=1772567495',
      b2yes: 'https://cdn.shopify.com/s/files/1/1826/4365/files/Fishing-Outline-Buttons.png?v=1772567496',
      b3yes: 'https://cdn.shopify.com/s/files/1/1826/4365/files/Pontoon-Outline-Buttons.png?v=1772567495',
      b4yes: 'https://cdn.shopify.com/s/files/1/1826/4365/files/Freshwater-Outline-Buttons.png?v=1772571206',
      b5yes: 'https://cdn.shopify.com/s/files/1/1826/4365/files/Center-Outline-Buttons.png?v=1772569450',
      b6yes: 'https://cdn.shopify.com/s/files/1/1826/4365/files/Sailboat-Outline-Buttons.png?v=1772567496',
      b7yes: 'https://cdn.shopify.com/s/files/1/1826/4365/files/Jetboat-Outline-Buttons_1.png?v=1772659189',
      b8yes: 'https://cdn.shopify.com/s/files/1/1826/4365/files/Inboard-Outline-Buttons.png?v=1772567496'
    }

    let bybForm = { //product recs based on quiz answers
      s3pUnit: 0,
      s3Unit: 0,
      annSub: 0,
      satUnit: 0,
      satSub: 0,
      entrySen: 0,
      batterySen: 0,
      bilgeSen: 0,
      highWaterSen: 0,
      microEpirSen: 0,
      infraredSen: 0,
      tempSen: 0, 
      canvasSnapSen: 0,
      audibleAlarm: 0,
      nmeaKit: 0,
      dcRelayWire: 0,
      shorePower120: 0,
      shorePower240: 0,
      shorePowerPlug: 0
    }

    // Hubspot properties : include all quiz question options, if user selects a 
    // option the userProperties[param] is set to true or corresponding integer value.  
    let userProperties = {
      email: "",
      properties:  {
        has_s3pro: false,
        boat_type___bass_util: false,
        boat_type___alum_fishing: false,
        boat_type___pontoon: false,
        boat_type___bay_flats_skiff_inflatable: false,
        boat_type___offshore_center_console: false,
        boat_type___sailboat: false,
        concern___unauthorized_entry: false,
        concern___sinking: false,
        concern___gear_theft: false,
        concern___boat_theft: false,
        concern___boat_health: false,
        bilge_pump_count: 0,
        entry___storage_spaces_to_monitor: 0,
        battery_bank_count: 0,
        control___outputs: false,
        control___relays: false,
        control___digital_switching: false,
        boat_storage___dock: false,
        boat_storage___trailer: false,
        boat_storage___mooring: false,
        boat_storage___dry_storage: false,
        boat_storage___other: false,
        boat_charging___120v: false,
        boat_charging___240v: false,
        boat_charging___none: false
      }
    }

    let sendOfferEmail = document.getElementById("byb-email-user-input").value;
    let s3mandatory = false;
    let s3pmandatory = false;
    let wirelessTotal = 0;
    let wiredTotal = 0;
    //Iterate through each item, tally recommendations per ques
    //ques1 will go last, determining s3 vs s3p based on sensor totals
    
    //ques3
    if(document.getElementById('byb-btn-ques3-1').classList.contains('byb-btn-active')){
      // bybForm.canvasSnapSen = 1; 
      // bybForm.audibleAlarm = 1; //canvas snap & audible alarm recs moved to follow-up ques 5A
      // wiredTotal += 2;
      // bybForm.microEpirSen = 1;
      userProperties.properties.concern___unauthorized_entry = true;
    } 
    if(document.getElementById('byb-btn-ques3-2').classList.contains('byb-btn-active')){
      bybForm.highWaterSen = 1;
      wirelessTotal += 1;
      userProperties.properties.concern___sinking = true;
    }
    if(document.getElementById('byb-btn-ques3-3').classList.contains('byb-btn-active')){
      // bybForm.microEpirSen = 1;
      userProperties.properties.concern___gear_theft = true;
    }
    if(document.getElementById('byb-btn-ques3-4').classList.contains('byb-btn-active')){
      // if(!s3mandatory){
      //   bybForm.satUnit = 1;
      //   bybForm.satSub = 1;
      //   s3pmandatory = true;
      // }
      userProperties.properties.concern___boat_theft = true;
    }
    if(document.getElementById('byb-btn-ques3-5').classList.contains('byb-btn-active')){
      bybForm.highWaterSen = 1; 
      bybForm.tempSen = 1; 
      bybForm.nmeaKit = 1; 
      wirelessTotal += 2;
      wiredTotal += 1;
      userProperties.properties.concern___boat_health = true;       
    }
    //ques3a
    if(document.getElementById('byb-btn-ques3a-1').classList.contains('byb-btn-active')){
      console.log('sirensat selected');
        bybForm.satUnit = 1;
        bybForm.satSub = 1;
        s3pmandatory = true;
    }
    //ques4

    let bilgeQuant = document.getElementById("byb-ques-4").valueAsNumber;
    bybForm.bilgeSen = bilgeQuant;
    wirelessTotal += bilgeQuant;
    userProperties.properties.bilge_pump_count = bilgeQuant;
    
    //ques5
    let entryQuant = document.getElementById("byb-ques-5").valueAsNumber;
    bybForm.entrySen = entryQuant;
    wirelessTotal += entryQuant;
    userProperties.properties.entry___storage_spaces_to_monitor = entryQuant;

    //ques5a
    let canvasQuant = document.getElementById("byb-ques-5a1").valueAsNumber;
    bybForm.canvasSnapSen = canvasQuant;
    let audibleQuant = document.getElementById("byb-ques-5a2").valueAsNumber;
    bybForm.audibleAlarm = audibleQuant;
    wiredTotal += canvasQuant;
    wiredTotal += audibleQuant;

    //ques6
    let battQuant = document.getElementById("byb-ques-6").valueAsNumber;
    if(battQuant > 0){ //S3P supports 2 battery monitoring w/o sensor; S3 supports 1
      let isS3 = document.getElementById('byb-ques1-opt1').checked;
      let isS3P = document.getElementById('byb-ques1-opt3').checked;
      if(isS3){
        battQuant--;
      } else if(isS3P){
        battQuant = battQuant - 2;
      }
      if(battQuant < 0){
        battQuant = 0;
      }
    }
    bybForm.batterySen = battQuant;
    wirelessTotal += battQuant;
    userProperties.properties.battery_bank_count = battQuant;

    //ques7
    if(document.getElementById('byb-btn-ques7-1').classList.contains('byb-btn-active')){
      userProperties.properties.control___outputs = true
    }
    if(document.getElementById('byb-btn-ques7-2').classList.contains('byb-btn-active')){
      if(!s3mandatory){
        bybForm.dcRelayWire = 1;
      }
      userProperties.properties.control___relays = true;
    }
    if(document.getElementById('byb-btn-ques7-3').classList.contains('byb-btn-active')){
      bybForm.nmeaKit = 1;
      s3pmandatory = true;
      userProperties.properties.control___digital_switching = true; 

    }
    
    //ques8
    //NO PRODUCT RECOMMENDATIONS NEEDED AT THIS TIME
    if(document.getElementById("byb-ques8-opt1").checked) {
      userProperties.properties.boat_storage___dock = true;
    } 
    else if(document.getElementById("byb-ques8-opt2").checked) {
      userProperties.properties.boat_storage___trailer = true;
    } 
    else if(document.getElementById("byb-ques8-opt3").checked) {
      userProperties.properties.boat_storage___mooring = true;
    } 
    else if(document.getElementById("byb-ques8-opt4").checked) {
      userProperties.properties.boat_storage___dry_storage = true;
    } 
    else {
      userProperties.properties.boat_storage___other= true; 
    } 
    
    
    //ques9
    if(document.getElementById("byb-ques9-opt1").checked){
      if(!s3mandatory){
        console.log('in shorepower120');
        bybForm.shorePower120 = 1;
        s3pmandatory = true;
      }
      // bybForm.shorePowerPlug = 1;
      userProperties.properties.boat_charging___120v = true;
    }else if(document.getElementById("byb-ques9-opt2").checked){
      if(!s3mandatory){
        bybForm.shorePower240 = 1;
        s3pmandatory = true;
      }
      // bybForm.shorePowerPlug = 1;
      userProperties.properties.boat_charging___240v = true;
    } 
    else {
      userProperties.properties.boat_charging___none = true; 
    }

    //ques2
    if(document.getElementById("byb-ques2-opt1").src == icons.b1yes) {
      userProperties.properties.boat_type___bass_util = true;     
    } 
    else if (document.getElementById("byb-ques2-opt2").src == icons.b2yes){
      userProperties.properties.boat_type___alum_fishing = true;
    }
    else if (document.getElementById("byb-ques2-opt3").src == icons.b3yes){
      userProperties.properties.boat_type___pontoon = true;
    }
    else if (document.getElementById("byb-ques2-opt4").src == icons.b4yes){
      userProperties.properties.boat_type___bay_flats_skiff_inflatable = true;
    }
    else if (document.getElementById("byb-ques2-opt5").src == icons.b5yes){
      userProperties.properties.boat_type___offshore_center_console = true;
    }
    else if (document.getElementById("byb-ques2-opt6").src == icons.b6yes){
      userProperties.properties.boat_type___sailboat = true; 
    }
    else if (document.getElementById("byb-ques2-opt7").src == icons.b7yes){ //jetboat
      s3mandatory = true;
    }
    else if (document.getElementById("byb-ques2-opt8").src == icons.b8yes){ //inboard-stern
      s3pmandatory = true;
    }

    //ques1
    if(document.getElementById("byb-ques1-opt2").checked){
      if(s3pmandatory){
        bybForm.s3pUnit = 1;
      } else if(s3mandatory){
        bybForm.s3Unit = 1;
      } else if(wirelessTotal > 6 || wiredTotal > 1) {
        bybForm.s3pUnit = 1;
      } else {
        if(bybForm.shorePower240 > 0 || bybForm.shorePower120 > 0 || bybForm.satUnit > 0 || bybForm.dcRelayWire > 1){
          bybForm.s3pUnit = 1;
        } else {
          bybForm.s3Unit = 1;
        }
      }
      bybForm.annSub = 1;
      if(bybForm.s3Unit > 0){ //set S3 incompatible sensors to zero
        bybForm.shorePower240 = 0;
        bybForm.shorePower120 = 0;
        bybForm.satUnit = 0;
        bybForm.satSub = 0;
        if(bybForm.dcRelayWire > 0){
          bybForm.dcRelayWire = 1;
        }
        if(bybForm.batterySen > 0){
          bybForm.batterySen--;
        }
      } else if(bybForm.s3pUnit > 0){
        if(bybForm.batterySen > 0){
          if(bybForm.batterySen === 1){
            bybForm.batterySen--;
          } else {
            bybForm.batterySen -= 2;
          }
        }
      }
      userProperties.properties.has_s3pro = false;
    } else if(document.getElementById("byb-ques1-opt1").checked){ //s3 owners get s3p exclusive products removed from cart
        bybForm.shorePower240 = 0;
        bybForm.shorePower120 = 0;
        bybForm.satUnit = 0;
        bybForm.satSub = 0;
        if(bybForm.dcRelayWire > 0){
          bybForm.dcRelayWire = 1;
        }
    }
        console.log('post ques1 - pre pruneForm. bybForm: ', bybForm);

    //Final step: Ques 2 should prune the bybForm into a new form, and non-plural sensors should get reduced to 1
    let recs = bybPruneForm(bybForm);
        console.log('post pruneForm. recs: ', JSON.stringify(recs));

    bybShowRecs(recs); //render results based on tallies
    
    //then, submit Hubspot form
    // Only update Hubspot properties when a user enters an Email in either email field
    userProperties.email = document.getElementById("byb-ques10-pt2").value;
    if(userProperties.email || sendOfferEmail) {
      // if userProperties email exists, use that email, if email me my offer email is entered used that one instead
      userProperties.email = sendOfferEmail ? sendOfferEmail : userProperties.email;
      let baseUrl = "https://internal-api.sirenmarine.com";
      axios.post(`${baseUrl}/byb/update-hubspot-user`, userProperties)
        .then(function (response) {
          // console.log(response);
        })
        .catch(function (error) {
          console.log(error);
        });
    }
}

  function bybPruneForm(form){
    let recsByBoatType = { 
      bassUtil: {
        s3pUnit: 0,
        s3Unit: 0,
        annSub: 0,
        tempSen: 0,
        entrySen: 0,
        batterySen: 0,
        dcRelayWire: 0,
        audibleAlarm: 0,
        nmeaKit: 0
      },
      alumWalleye: {
        s3pUnit: 0,
        s3Unit: 0,
        annSub: 0,
        tempSen: 0,
        batterySen: 0,
        dcRelayWire: 0,
        nmeaKit: 0,
        audibleAlarm: 0,
        entrySen: 0,
        highWaterSen: 0,
        microEpirSen: 0,
        infraredSen: 0
      },
      deckPontoon: {
        s3pUnit: 0,
        s3Unit: 0,
        annSub: 0,
        tempSen: 0,
        entrySen: 0,
        dcRelayWire: 0,
        audibleAlarm: 0,
        canvasSnapSen: 0,
        nmeaKit: 0
      },
      bayFlats: {
        s3pUnit: 0,
        s3Unit: 0,
        annSub: 0,
        tempSen: 0,
        batterySen: 0,
        dcRelayWire: 0,
        nmeaKit: 0,
        highWaterSen: 0,
        entrySen: 0
      },
      centerConsole: {
        s3pUnit: 0,
        s3Unit: 0,
        annSub: 0,
        satUnit: 0,
        satSub: 0,
        tempSen: 0,
        batterySen: 0,
        nmeaKit: 0,
        bilgeSen: 0,
        highWaterSen: 0,
        dcRelayWire: 0,
        shorePower120: 0,
        shorePower240: 0,
        shorePowerPlug: 0,
        audibleAlarm: 0,
        entrySen: 0,
        canvasSnapSen: 0,
        microEpirSen: 0,
        infraredSen: 0
      },
      sailboat: {
        s3pUnit: 0,
        s3Unit: 0,
        annSub: 0,
        satUnit: 0,
        satSub: 0,
        tempSen: 0,
        dcRelayWire: 0,
        microEpirSen: 0,
        infraredSen: 0,
        bilgeSen: 0,
        highWaterSen: 0,
        entrySen: 0,
        batterySen: 0
      },
      jetboat: {
        s3pUnit: 0,
        s3Unit: 0,
        annSub: 0,
        entrySen: 0,
        batterySen: 0,
        bilgeSen: 0,
        highWaterSen: 0,
        tempSen: 0, 
        canvasSnapSen: 0,
        audibleAlarm: 0,
        dcRelayWire: 0,
      },
      inboardstern: {
        s3pUnit: 0,
        s3Unit: 0,
        annSub: 0,
        entrySen: 0,
        batterySen: 0,
        bilgeSen: 0,
        highWaterSen: 0,
        tempSen: 0, 
        canvasSnapSen: 0,
        audibleAlarm: 0,
        nmeaKit: 0,
        dcRelayWire: 0,
        shorePower120: 0,
        shorePower240: 0,
      }
    }
    let icons = {
      b1yes: 'https://cdn.shopify.com/s/files/1/1826/4365/files/Saltwater-Outline-Buttons.png?v=1772567495',
      b2yes: 'https://cdn.shopify.com/s/files/1/1826/4365/files/Fishing-Outline-Buttons.png?v=1772567496',
      b3yes: 'https://cdn.shopify.com/s/files/1/1826/4365/files/Pontoon-Outline-Buttons.png?v=1772567495',
      b4yes: 'https://cdn.shopify.com/s/files/1/1826/4365/files/Freshwater-Outline-Buttons.png?v=1772571206',
      b5yes: 'https://cdn.shopify.com/s/files/1/1826/4365/files/Center-Outline-Buttons.png?v=1772569450',
      b6yes: 'https://cdn.shopify.com/s/files/1/1826/4365/files/Sailboat-Outline-Buttons.png?v=1772567496',
      b7yes: 'https://cdn.shopify.com/s/files/1/1826/4365/files/Jetboat-Outline-Buttons_1.png?v=1772659189',
      b8yes: 'https://cdn.shopify.com/s/files/1/1826/4365/files/Inboard-Outline-Buttons.png?v=1772567496'
    }
    let imgtags = {
      b1: document.getElementById('byb-ques2-opt1'),
      b2: document.getElementById('byb-ques2-opt2'),
      b3: document.getElementById('byb-ques2-opt3'),
      b4: document.getElementById('byb-ques2-opt4'),
      b5: document.getElementById('byb-ques2-opt5'),
      b6: document.getElementById('byb-ques2-opt6'),
      b7: document.getElementById('byb-ques2-opt7'),
      b8: document.getElementById('byb-ques2-opt8')
    }

    let package;
    //determine boat type selected
    if(imgtags.b1.src == icons.b1yes){
      package = recsByBoatType.bassUtil;
    }else if(imgtags.b2.src == icons.b2yes){
      package = recsByBoatType.alumWalleye;
    }else if(imgtags.b3.src == icons.b3yes){
      package = recsByBoatType.deckPontoon;
    }else if(imgtags.b4.src == icons.b4yes){
      package = recsByBoatType.bayFlats;
    }else if(imgtags.b5.src == icons.b5yes){
      package = recsByBoatType.centerConsole;
    }else if(imgtags.b6.src == icons.b6yes){
      package = recsByBoatType.sailboat;
    }else if(imgtags.b7.src == icons.b7yes){
      package = recsByBoatType.jetboat;
    }else if(imgtags.b8.src == icons.b8yes){
      package = recsByBoatType.inboardstern;
    }
    for(let prod in package){
    package[prod] = form[prod];
    }
    return package;
  }

  function bybShowRecs(formObj){
    //Toggle visibility for product cards based on formObj
    for(var prod in formObj){
      if(formObj[prod] > 0){
        let cardId = 'byb-res-card-' + prod;
        let cardQuant = 'byb-res-card-quantity-' + prod;
        document.getElementById(cardId).style.display = "flex";
        document.getElementById(cardQuant).value = formObj[prod];
      }
    }
    //Hide quiz visilibity
    document.getElementById('byb-quiz-root').style.display = "none";
    //Make results visible
    document.getElementById('byb-result-root').style.display = "block";
  }

  function bybAddToCart(){
    let mappings = { //product ids for all prods - SUBS MUST USE VARIANT ID INSTEAD!!
      annSub: 33869986189,
      satUnit: 29561849282630,
      satSub: 20660409204806,
      entrySen: 31891448758342,
      batterySen: 31891393577030,
      bilgeSen: 31891437944902,
      highWaterSen: 31891457048646,
      tempSen: 31891459964998,
      // microEpirSen: 35154413197,
      // infraredSen: 33687256717, 
      canvasSnapSen: 35154849101,
      audibleAlarm: 43218940428358, //replaced w/ mini-alarm product id
      nmeaKit: 32064103972934,
      dcRelayWire: 38745872845,
      s3pUnit: 31927087530054,
      s3Unit: 42944623640646,
      shorePower120: 32231629324358, //s3p only
      shorePower240: 19266749988934, //s3p only
      shorePowerPlug: 35155160461 //s3p only
    }

    let cart = [];
    for(var prod in mappings){ //capture all products & assoc quantities visible on results pg
      let cardId = 'byb-res-card-' + prod;
      let cardQuant = 'byb-res-card-quantity-' + prod;
      if(document.getElementById(cardId).style.display === "flex") {
        let quant = parseInt(document.getElementById(cardQuant).value);
        if(!isNaN(quant)){ //if quantity > 0, add to cart object
          //add selling plans for subscriptions
          if(mappings[prod] === 33869986189){ //annual cell sub
            cart.push([1, mappings[prod], 3602120774])
          } else if(mappings[prod] === 20660409204806){ //1yr SirenSat sub
            cart.push([1, mappings[prod], 3602088006])
          } else {
            cart.push([quant, mappings[prod]]);
          }
        }
      }
    }
    //'filter' out 0 quantity items, 'map' them for axios format
    let items = cart.filter(item => item[0] !== 0).map(item => {
      let obj = { quantity: item[0], id: item[1] };
      if (item[2] !== undefined) { //item[2] will contain selling plan IF product is subscription
        obj.selling_plan = item[2];
      }
      return obj;
    });



    axios.post('/cart/add.js', { items })
    .then(function (response) {
      return axios.get('/cart.js');
    })
    .then(function(response){
      var cartCountHTML = $('#CartCount');
      cartCountHTML.text(response.data.item_count);
    })
    .then(function (b) {
      swal({
        title: '<span style="color:#f16921">Success!</span>',
        html: true,
        showCloseButton:false,
        showConfirmButton:false,
        showCancelButton:false,
        text:
          '<p>Items have been added to cart.</p><div><button id="closeModal" style="border: 1px solid #f16921;color:#f16921;background-color:white;border-radius:10px;padding:7px 32px">Keep Shopping</button><button id="goToCart" style="background-color:#f16921;border-radius:10px;padding:7px 32px">Go to Cart</button></div>',
      });
      $("#goToCart").click(() => {
        window.location.href="/cart"
      });
    })
    .catch(function (error) {
      console.log('error: ', error);
    });
  }

  function liveUpdateEmailInput(emailForm) {
    emailError = document.getElementById("emailError");
    if(!validateEmailByb(emailForm.value)) {
      // DOM edit the textbox (make it red)
      // alert user whats wrong with email
      emailForm.style.borderColor = "#d02e2e";
      emailForm.style.color = "#d02e2e";
      emailError.textContent = 'Please enter a valid email address.';
      emailError.style.display = 'block';
      return
    } else {
      emailForm.style.color = "#555"
      emailForm.style.borderColor = "#b4b4b4"
      emailError.textContent = '';
      emailError.style.display = 'none';
    }
  }
  // Generates a productList needed for Postmark to display products in user's email
  // If the one of the products exists in productList, it will exist in the email. 
  function bybSendOffers(userEmail) {
    let productList = { // Do not change format of data
        email: userEmail, 
        prodData : {
        s3pUnit : "",
        s3Unit: "",
        annSub : "",
        satUnit : "",
        satSub : "",
        entrySen : "",
        batterySen : "",
        bilgeSen : "",
        highWaterSen : "",
        microEpirSen : "",
        infaredSen : "",
        tempSen : "",
        canvasSnapSen : "",
        audibleAlarm : "",
        nmeaKit : "",
        dcRelayWire : "",
        shorePower120 : "",
        shorePower240 : "",
        shorePowerPlug : ""}
     };

    let prodQuantities = { // Do not change format of data
        s3pUnit_quantity: {s3pUnit_quantity : ""},
        annSub_quantity: {},
        satUnit_quantity: {},
        satSub_quantity: {},
        entrySen_quantity: {},
        batterySen_quantity: {},
        bilgeSen_quantity: {},
        highWaterSen_quantity: {},
        microEpirSen_quantity: {},
        infaredSen_quantity: {},
        tempSen_quantity: {},
        canvasSnapSen_quantity: {},
        audibleAlarm_quantity: {},
        nmeaKit_quantity: {},
        dcRelayWire_quantity: {},
        shorePower120_quantity: {},
        shorePower240_quantity: {},
        shorePowerPlug_quantity: {}
     };

    // Retrieve all the result cards from the quiz page
    const all_results = document.getElementsByClassName('byb-res-cards-all');

    // Get the products from all the result cards
    let products = all_results[0].children;

    // For each product, extract product data
    for(let i=0; i<products.length; i++) {
        if(products[i].style.display === "flex") {
          let productName = products[i].getAttribute("id");
          let productID = productName.substring(productName.lastIndexOf("-")+1);
          let prodNameQuantity = productID.concat("_quantity"); 
          let quantity_value = document.querySelector(`#${productName} .byb-num-input`).value;
          prodQuantities[prodNameQuantity][prodNameQuantity] = quantity_value
          productList.prodData[productID] = prodQuantities[prodNameQuantity]
        }
    }

    // Make an axios call to backend server to perform emailing to client
    let baseUrl = "https://internal-api.sirenmarine.com";
    axios.post(`${baseUrl}/byb/offer-suggestion`, productList)
      .then(function (response) {
        // console.log(response);
      })
      .catch(function (error) {
        console.log(error);
      });
    // update hubspot user when email me my offer button is hit
    bybProcessForm();
  }
  
  // Based on Regex Expression, validate if a user enters a correct email, characters in email must match conditions in this statement
  const validateEmailByb = (email) => {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
  };

  // After user types in email and submits the form, display a success modal
  function successEmailDisplay() {
    let sucessHeader = document.querySelector("#send-email-modal h2");
    let successText = document.querySelector("#send-email-modal .direct-atc-modal-text");
    let sendOfferBtn = document.getElementById("send-offer-btn");
    let returnBackBtn = document.getElementById("back-to-page-btn");
    let emailInput = document.getElementById("byb-email-user-input");

    sucessHeader.innerHTML = "Email Sucessfully Sent";
    successText.textContent = "Check your email to view your products";
    sendOfferBtn.classList.add("hidden-elem");
    returnBackBtn.classList.remove("hidden-elem");
    returnBackBtn.classList.add("byb-input-block");
    emailInput.classList.add("hidden-elem");

    // Add the shake class
    sucessHeader.classList.add("shake");

    // Remove the shake class after the animation is complete
    setTimeout(() => {
      sucessHeader.classList.remove("shake");
    }, 1000); 
  }
  
  